import { Locale } from '@internal/utils/machine/i18n/Locale'
import { TLocalizedUrlMap } from 'i18n/TLocalizedUrlMap'

// this used to use urlFor, but that created a problem in the middleware
const localizations: TLocalizedUrlMap = {
  [Locale.de]: `/${Locale.de}/`,
  [Locale.en]: `/${Locale.en}/`,
  [Locale.fr]: `/${Locale.fr}/`,
  [Locale.el]: `/${Locale.el}/`,
  [Locale.it]: `/${Locale.it}/`,
  [Locale.pl]: `/${Locale.pl}/`,
  [Locale.ro]: `/${Locale.ro}/`,
  [Locale.ru]: `/${Locale.ru}/`,
  [Locale.hu]: `/${Locale.hu}/`,
  [Locale.es]: `/${Locale.es}/`,
  [Locale.bg]: `/${Locale.bg}/`,
  [Locale.sl]: `/${Locale.sl}/`,
  [Locale.sr]: `/${Locale.sr}/`,
  [Locale.da]: `/${Locale.da}/`,
  [Locale.cs]: `/${Locale.cs}/`,
  [Locale.lt]: `/${Locale.lt}/`,
}

export const getLocalizedUrlMapForStartPage = () => localizations
